export default __webpack_public_path__ + "static/media/sakura-no-1.5f570a37.mid";